export const T = {
  en_GB: {
    addCombinedInstrument: "Add Combined Instrument",
    deleteTitle: "Delete Combined Instrument",
    deleteDescription: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    deleteSuccess: "Combined instrument deleted",
    deleteFailed: "Failed to delete combined instrument",
    inUse: "This combined instrument cannot be deleted because it is in use:",
    usedByProducts: "Portfolio products: ",
    usedByAssetClasses: "Asset classes: ",
    usedByCombined: "Combined instruments: ",
  },
  nb_NO: {
    addCombinedInstrument: "Legg til kombinert instrument",
    deleteTitle: "Slett kombinert instrument",
    deleteDescription: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    deleteSuccess: "Kombinert instrument slettet",
    deleteFailed: "Kunne ikke slette kombinert instrument",
    inUse: "Dette kombinerte instrumentet kan ikke slettes fordi det er i bruk:",
    usedByProducts: "Porteføljeprodukter: ",
    usedByAssetClasses: "Aktivaklasser: ",
    usedByCombined: "Kombinerte instrumenter: ",
  },
} as const;
